import React, { useState, useEffect } from "react";

function SchoolSearch() {
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [grades, setGrades] = useState([]);
  const [schools, setSchools] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedGrade, setSelectedGrade] = useState("");
  const [selectedSchool, setSelectedSchool] = useState("");
  const [serviceurl, setServiceurl] = useState("#");
  const [message, setMessage] = useState("");
 
//url: http://10.254.136.52
//url: http://10.254.136.52
  useEffect(() => {
    fetch("https://static.viettelmoney.vn/shool_app/public/api/getallprovinces")
      .then((response) => response.json())
      .then((data) => setProvinces(data));
    }, []);

  const handleProvinceChange = (event) => {
    setSelectedProvince(event.target.value);
    setSelectedDistrict("");
    setMessage("");
    setServiceurl("#");
    fetch("https://static.viettelmoney.vn/shool_app/public/api/getdistricts/"+event.target.value)
    .then((response) => response.json())
    .then((data) => {setDistricts(data)});
  };

  const handleDistrictChange = (event) => {
    setSelectedDistrict(event.target.value);
    setSelectedGrade("");
    setMessage("");
    setServiceurl("#");
    fetch("https://static.viettelmoney.vn/shool_app/public/api/getgrades/"+event.target.value)
    .then((response) => response.json())
    .then((data) => {setGrades(data)});
  };

  const handleGradeChange = (event) => {
    setSelectedGrade(event.target.value);
    setSelectedSchool("");
    setMessage("");
    setServiceurl("#");
    fetch("https://static.viettelmoney.vn/shool_app/public/api/getschools/"+event.target.value)
    .then((response) => response.json())
    .then((data) => {setSchools(data)});
  };

  const handleSchoolChange = (event) => {
    setSelectedSchool(event.target.value);
    setServiceurl('viettelpay.onelink.me://action/t='+event.target.selectedOptions[0].attributes[1].value+'&c='+event.target.selectedOptions[0].attributes[2].value);
    setMessage("");
  };

  const handleSubmit = () => {
    if (serviceurl=="#") {
      setMessage('Vui lòng chọn trường học.')
    }else{
      setMessage("");
    }
  };


  const districtOptions = districts[selectedProvince] || [];
  const gradeOptions = grades[selectedDistrict] || [];
  const schoolOptions = schools[selectedGrade] || [];

  return (
    <div>
      <div class="row justify-content-center">
        <div class="col">
          <label>
            Tỉnh/Thành phố:
          </label>
        </div>
        <div class="col">
        <select value={selectedProvince} onChange={handleProvinceChange}>
          <option value="">--Chọn--</option>
          {provinces.map((province) => (
            <option key={province.p_code} value={province.p_code}>
              {province.p_name}
            </option>
          ))}
        </select>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col">
          <label>
            Quận/Huyện:
          </label>
        </div>
        <div class="col">
        <select value={selectedDistrict} onChange={handleDistrictChange}>
          <option value="">--Chọn--</option>
          {districts.map((district) => (
            <option key={district.d_code} value={district.d_code}>
              {district.d_name}
            </option>
          ))}
        </select>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col">
          <label>
            Cấp học:
          </label>
        </div>
        <div class="col">
        <select value={selectedGrade} onChange={handleGradeChange}>
          <option value="">--Chọn--</option>
          {grades.map((grades) => (
            <option key={grades.g_code} value={grades.g_code}>
              {grades.g_name}
            </option>
          ))}
        </select>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col">
          <label>
            Trường:
          </label>
        </div>
        <div class="col">
        <select value={selectedSchool} onChange={handleSchoolChange}>
          <option value="">--Chọn--</option>
          {schools.map((truong) => (
            <option key={truong.s_code} value={truong.s_code} stype={truong.ser_type} scode={truong.ser_code}>
              {truong.s_name}
            </option>
          ))}
        </select>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12">
            <p id="msg">{message}</p>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12">
          <a class="button action_ct_1" href={serviceurl} onClick={handleSubmit}>Tra cứu ngay</a>
        </div>
      </div>
    </div>
  );
}

export default SchoolSearch;
